import PaginatedItemOverview, { DEFAULT_PAGINATION } from "./PaginatedItemOverview";
export { DEFAULT_PAGINATION };
export default PaginatedItemOverview;
